import { render, staticRenderFns } from "./SettingsButtonEditor.vue?vue&type=template&id=655e3198&scoped=true&"
import script from "./SettingsButtonEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsButtonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e3198",
  null
  
)

export default component.exports